import { watch } from 'vue'

export const usePreFilters = ({ gridApi, filters }) => {
  watch(filters, () => {
    gridApi.value.refreshServerSide({ purge: true })
  })
}
